module.exports = __webpack_public_path__ + "static/media/home-process-1.b8e3aef6.svg";